export const variablesList = {
  mainTheme: {
    defaultTabBg: '#053170',
    tabSelected: '#053170',
    iconButtonBg: '#053170',
    iconButtonBgHover: '#63a0c0',
    menuBackground: '#053170',
    menuBorder: '1px solid #5eaec6',
    buttonPrimaryBgHover: '#63a0c0',
    menuColor: '#FFFFFF',
    menuColorHover: '#ffb58a',
    menuItemBg: '#c065a2',
    colorBorder: '2px solid #053170',
    checkboxBorder: '2px solid #053170',
    colorTypography: '#053170',
    tableCellColor: '#FFFFFF',
    datePickerDayColor: '#053170',
    tableBorder: '#5eaec6',
    bgColor: '#93b1c1',
    nestedTableBorder: '1px solid #5eaec6',
    filterLabelColor: '#4b5563',
  },
  contrastBloom: {
    defaultTabBg: '#3a68aa',
    tabSelected: '#1b1860',
    iconButtonBg: '#1b1860',
    iconButtonBgHover: '#3a68aa',
    menuBackground: '#1b1860',
    menuBorder: '1px solid #44a7fb',
    buttonPrimaryBgHover: '#3a68aa',
    menuColor: '#FFFFFF',
    menuColorHover: '#f69906',
    menuItemBg: '#765cc9',
    colorBorder: '2px solid #1b1860',
    checkboxBorder: '2px solid #1b1860',
    colorTypography: '#1b1860',
    tableCellColor: '#FFFFFF',
    datePickerDayColor: '#1b1860',
    tableBorder: '#44a7fb',
    bgColor: '#162b48',
    nestedTableBorder: '1px solid #44a7fb',
    filterLabelColor: '#ffffff',
  },
  firstTheme: {
    defaultTabBg: '#3a68aa',
    tabSelected: '#44a7fb',
    iconButtonBg: '#3a68aa',
    iconButtonBgHover: '#2c5280',
    menuBackground: '#010405',
    menuBorder: '1px solid #3a68aa',
    buttonPrimaryBgHover: '#2c5280',
    menuColor: '#ffffff',
    menuColorHover: '#44a7fb',
    menuItemBg: '#0b1220',
    colorBorder: '2px solid #3a68aa',
    checkboxBorder: '2px solid #44a7fb',
    colorTypography: '#ffffff',
    tableCellColor: '#ffffff',
    datePickerDayColor: '#44a7fb',
    tableBorder: '#3a68aa',
    bgColor: '#0b1220',
    nestedTableBorder: '1px solid #3a68aa',
    filterLabelColor: '#ffffff',
  },
  secondTheme: {
    defaultTabBg: '#3A68AA',
    tabSelected: '#1A73E8',
    iconButtonBg: '#1A73E8',
    iconButtonBgHover: '#145ABD',
    menuBackground: '#111111',
    menuBorder: '1px solid #A0AEC0',
    buttonPrimaryBgHover: '#145ABD',
    menuColor: '#ffffff',
    menuColorHover: '#1A73E8',
    menuItemBg: '#D6E4FF',
    colorBorder: '2px solid #63A0C0',
    checkboxBorder: '2px solid #1A73E8',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: '#1A73E8',
    tableBorder: '#A0AEC0',
    bgColor: '#FFFFFF',
    nestedTableBorder: '1px solid #A0AEC0',
    filterLabelColor: '#4b5563',
  },
  fifthTheme: {
    defaultTabBg: '#C065A2',
    tabSelected: '#C065A2',
    iconButtonBg: '#C065A2',
    iconButtonBgHover: '#A0548C',
    menuBackground: '#111111',
    menuBorder: '1px solid #C065A2',
    buttonPrimaryBgHover: '#A0548C',
    menuColor: '#ffffff',
    menuColorHover: '#C065A2',
    menuItemBg: '#F8E6F1',
    colorBorder: '2px solid #C065A2',
    checkboxBorder: '2px solid #C065A2',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: '#C065A2',
    tableBorder: '#A0AEC0',
    bgColor: '#FFFFFF',
    nestedTableBorder: '1px solid #C065A2',
    filterLabelColor: '#4b5563',
  },
  seventhTheme: {
    defaultTabBg: '#2E8B57',
    tabSelected: '#2E8B57',
    iconButtonBg: '#2E8B57',
    iconButtonBgHover: '#1F5E3A',
    menuBackground: '#111111',
    menuBorder: '1px solid #2E8B57',
    buttonPrimaryBgHover: '#1F5E3A',
    menuColor: '#ffffff',
    menuColorHover: '#2E8B57',
    menuItemBg: '#E6F4EA',
    colorBorder: '2px solid #2E8B57',
    checkboxBorder: '2px solid #2E8B57',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: '#2E8B57',
    tableBorder: '#DCE5DD',
    bgColor: '#F1F8F4',
    nestedTableBorder: '1px solid #2E8B57',
    filterLabelColor: '#4b5563',
  },
  eighthTheme: {
    defaultTabBg: '#5a6f94',
    tabSelected: 'rgba(103, 189, 197, 0.7)',
    iconButtonBg: '#5a6f94',
    iconButtonBgHover: 'rgba(172, 196, 221, 0.5)',
    menuBackground: 'rgba(172, 196, 221, 0.7)',
    menuBorder: '1px solid #5a6f94',
    buttonPrimaryBgHover: '#99b8d6',
    menuColor: 'rgba(172, 196, 221, 0.7)',
    menuColorHover: '#fff',
    menuItemBg: 'rgba(172, 196, 221, 0.5)',
    colorBorder: '2px solid #5a6f94',
    checkboxBorder: '2px solid rgba(172, 196, 221)',
    colorTypography: '#5a6f94',
    tableCellColor: '#000',
    datePickerDayColor: '#5a6f94',
    tableBorder: '#fff',
    bgColor: 'rgba(172, 196, 221, 0.5)',
    nestedTableBorder: '1px solid white',
    titleBarBg: '#7190be',
    filterLabelColor: '#4b5563',
  },
  lilacTheme: {
    defaultTabBg: '#9A97D6',
    tabSelected: '#7F7BC4',
    iconButtonBg: '#9A97D6',
    iconButtonBgHover: '#7F7BC4',
    menuBackground: '#2F2C5A',
    menuBorder: '1px solid #9A97D6',
    buttonPrimaryBgHover: '#7F7BC4',
    menuColor: '#FFFFFF',
    menuColorHover: '#E8E9F7',
    menuItemBg: '#F4F5FD',
    colorBorder: '2px solid #9A97D6',
    checkboxBorder: '2px solid #9A97D6',
    colorTypography: '#2F2C5A',
    tableCellColor: '#2F2C5A',
    datePickerDayColor: '#9A97D6',
    tableBorder: '#E8E9F7',
    bgColor: '#FAFBFF',
    nestedTableBorder: '1px solid #E8E9F7',
    filterLabelColor: '#4b5563',
  },
  ninethTheeme: {
    defaultTabBg: '#6e5c4e',
    tabSelected: '#6e5c4e',
    iconButtonBg: '#6e5c4e',
    iconButtonBgHover: '#6e5c4e',
    menuBackground: '#6e5c4e',
    menuBorder: '1px solid rgb(55,91,161)',
    buttonPrimaryBgHover: 'rgba(243,174,65, 0.8)',
    menuColor: '#dbeff6',
    menuColorHover: '#fff',
    menuItemBg: 'rgba(219, 239, 246, 0.7)',
    colorBorder: '2px solid #6cf8ff',
    checkboxBorder: '2px solid rgb(243,174,65)',
    colorTypography: '#6e5c4e',
    tableCellColor: '#fff',
    datePickerDayColor: '#6e5c4e',
    tableBorder: '#6e5c4e',
    bgColor: 'rgb(244 126 9 / 0.8)',
    nestedTableBorder: '1px solid rgb(243,174,65)',
    titleBarBg: 'rgba(52, 92, 164, 0.5)',
    filterLabelColor: '#4b5563',
  },
  slateSteel: {
    defaultTabBg: 'rgb(60 81 97)',
    tabSelected: 'rgb(114, 138, 158)',
    iconButtonBg: 'rgb(60 81 97)',
    iconButtonBgHover: '#314553',
    menuBackground: '#F6F3EE',
    menuBorder: '1px solid #7E919F',
    buttonPrimaryBgHover: '#314553',
    menuColor: '#2A3944',
    menuColorHover: 'rgb(60 81 97)',
    menuItemBg: '#E8E1D8',
    colorBorder: '2px solid #7E919F',
    checkboxBorder: '2px solid #7E919F',
    colorTypography: '#2A3944',
    tableCellColor: '#2A3944',
    datePickerDayColor: 'rgb(60 81 97)',
    tableBorder: '#CBBFB2',
    bgColor: 'rgb(191 212 227)',
    nestedTableBorder: '1px solid #7E919F',
    filterLabelColor: '#2A3944',
  },
  turquoiseTheme: {
    defaultTabBg: '#0F766E',
    tabSelected: '#14B8A6',
    iconButtonBg: '#0F766E',
    iconButtonBgHover: '#14B8A6',
    menuBackground: '#134E4A',
    menuBorder: '1px solid #14B8A6',
    buttonPrimaryBgHover: '#0F766E',
    menuColor: '#FFFFFF',
    menuColorHover: '#99F6E4',
    menuItemBg: '#CCFBF1',
    colorBorder: '2px solid #0F766E',
    checkboxBorder: '2px solid #14B8A6',
    colorTypography: '#134E4A',
    tableCellColor: '#134E4A',
    datePickerDayColor: '#0F766E',
    tableBorder: '#5EEAD4',
    bgColor: '#F0FDFA',
    nestedTableBorder: '1px solid #5EEAD4',
    filterLabelColor: '#134E4A',
  },
  arcticHorizonTheme: {
    defaultTabBg: 'rgb(87 113 158)',
    tabSelected: 'rgb(196, 218, 240)',
    iconButtonBg: 'rgb(87 113 158)',
    iconButtonBgHover: '#145ABD',
    menuBackground: '#111111',
    menuBorder: '1px solid #A0AEC0',
    buttonPrimaryBgHover: 'rgb(87 113 158)',
    menuColor: '#ffffff',
    menuColorHover: 'rgb(87 113 158)',
    menuItemBg: '#D6E4FF',
    colorBorder: '2px solid #63A0C0',
    checkboxBorder: '2px solid rgb(87 113 158)',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: 'rgb(87 113 158)',
    tableBorder: '#A0AEC0',
    bgColor: '#FFFFFF',
    nestedTableBorder: '1px solid #A0AEC0',
    filterLabelColor: '#4b5563',
  },
};
